import { colors } from '../../config/constants';

type StorageProps = {
  lable?: string;
  onClick?: () => void;
  storage?: string;
  totalMemory: number;
  usedMemory: number;
};

const StorageBar = (props: StorageProps) => {
  const { totalMemory, usedMemory } = props;

  const convertToGB = (totalMemory: number, usedMemory: number) => {
    const totalGB = totalMemory / (1024 * 1024 * 1024);
    const usedGB = usedMemory / (1024 * 1024 * 1024);
    const result = (usedGB / totalGB) * 256;

    if (totalMemory === 0) {
      return 0;
    } else if (result > 256) {
      return 256;
    } else {
      return result;
    }
  };

  return (
    <div data-testid="Storagebar-wrapper">
      <div className="flex w-3/4 md:w-full justify-between items-center">
        <div className={`${colors.primaryText} text-sm font-semibold`}>
          {props.lable}
        </div>
      </div>
      <div
        className={`h-[20px] shadow-sm cursor-pointer rounded-sm border border-gray-300`}
        onClick={props.onClick}
        style={{ width: '256px' }}
      >
        <div
          style={{ width: `${convertToGB(totalMemory, usedMemory)}px` }}
          className={`h-[18px] rounded-sm flex items-center justify-evenly bg-[#50a0d9]`}
        ></div>
      </div>
      <div className={`text-[gray] mt-1 text-sm`}>{props.storage}</div>
    </div>
  );
};

export default StorageBar;
